export default __webpack_public_path__ + "static/media/Destination6.83898fff.png";